import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuaziDownloadPage from "../pages/guazi-download/page";
import GuaziReportPage from "../pages/guazi-report/GuaziReportPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/download",
    element: <GuaziDownloadPage />,
  },
  {
    path: "/report",
    element: <GuaziReportPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;